import type { SelectPriceProps } from "~/features/productDetails/components/ProductSummary/PdpSummaryHelper";
import { getListPrice } from "~/domains/product/utils/productDescriptorUtils";
import { PriceElements } from "~/domains/pricing/components/Price/PriceV4";

export const ListPrice = (props: Omit<SelectPriceProps, "quantity">) => {
  const price = getListPrice(props);

  if (!price || !price.value) {
    return null;
  }

  return (
    <PriceElements.Stack>
      <PriceElements.Price price={price} variant="titleMedium" fontWeight={"bold"} />
      <PriceElements.ListPriceLabel unit={price!.unit} variant="labelLarge" />
    </PriceElements.Stack>
  );
};
